/* eslint-disable @typescript-eslint/naming-convention */
export interface CheckOutResponseDto {
	ErrorCode: number;
	ErrorMessage: string;
	Workfile: string;
}
